import { render } from "./AddReview.vue?vue&type=template&id=5098f151&scoped=true"
import script from "./AddReview.vue?vue&type=script&lang=js"
export * from "./AddReview.vue?vue&type=script&lang=js"

import "./AddReview.vue?vue&type=style&index=0&id=5098f151&lang=scss&scoped=true"
import "./review.scss?vue&type=style&index=1&id=5098f151&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5098f151"]])

export default __exports__